export type PolicyType =
  | 'SHIPPING'
  | 'GUIDE'
  | 'OPERATION'
  | 'TERMS'
  | 'PRIVACY'
  | 'EMAIL_REJECT';

export const POLICY_TYPES: ReadonlyArray<PolicyType> = [
  'SHIPPING',
  'GUIDE',
  'OPERATION',
  'TERMS',
  'PRIVACY',
  'EMAIL_REJECT',
];

/**
 * Storefront 약관/법적 고지 정책 4종 (이용안내/이용약관/개인정보처리방침/이메일무단수집거부).
 * 신규 등록 폼의 기본 선택값을 이 집합 우선으로 둔다. 상품 정책(SHIPPING/OPERATION)은
 * 상품 폼 PolicySelect 에서 따로 쓰인다.
 */
export const SITE_POLICY_TYPES: ReadonlyArray<PolicyType> = [
  'GUIDE',
  'TERMS',
  'PRIVACY',
  'EMAIL_REJECT',
];

/**
 * 정책 한 로케일의 번역(catalog V127 policy_translation). 비어 있으면 국문 정본으로 폴백한다 — 해외몰 PDP
 * 배송안내·이용안내와 공개 정책 페이지가 쓴다.
 *
 * ★BE 는 받은 로케일의 name·content 를 **둘 다** 덮어쓴다(null 도 그대로 저장). 한쪽만 보내면 다른 쪽
 * 번역이 지워지므로, 보낼 때는 항상 두 필드를 함께 채운다(`buildPolicyTranslations`).
 */
export interface PolicyTranslation {
  name?: string | null;
  content?: string | null;
}

export interface Policy {
  id: number;
  type: PolicyType;
  name: string;
  content: string;
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  /** en-US / ja-JP / zh-CN 번역. 번역이 없는 로케일은 name·content 가 null 로 온다. V127 이전 응답에는 없다. */
  translations?: Record<string, PolicyTranslation> | null;
}

export interface PolicyCreatePayload {
  type: PolicyType;
  name: string;
  content: string;
  /** Defaults to true server-side when omitted. */
  isActive?: boolean;
  /** 해외몰 문구. 생략하면 번역 없이 등록된다. */
  translations?: Record<string, PolicyTranslation>;
}

export interface PolicyUpdatePayload {
  type: PolicyType;
  name: string;
  content: string;
  /** Omit to keep the current activation state. */
  isActive?: boolean;
  /**
   * 해외몰 문구. 생략하면 서버 번역을 그대로 둔다. 보낸 로케일만 바뀌고, 빈 값은 국문 폴백이다.
   * 로케일 키는 en-US / ja-JP / zh-CN 만 받는다.
   */
  translations?: Record<string, PolicyTranslation>;
}

export interface PolicyListQuery {
  type?: PolicyType;
  active?: boolean;
  /** UI page number, 1-based. Converted to the BE's 0-based Pageable at fetch time. */
  page: number;
  size: number;
}

export interface PolicyPagination {
  /** 1-based, as returned by the BE envelope meta. */
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
}

export interface PolicyListResult {
  items: Policy[];
  pagination: PolicyPagination;
}
